module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.controller) ? _c('div', [(!_vm.controller.IsUpdating_Dosage) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.controller.IsNew) ? _c('div', [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.controller.drug.hasError, 'has-warning': _vm.controller.drug.hasWarning, 'has-success': _vm.controller.drug.hasSuccess
    },
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "focusedInput"
    }
  }, [_vm._v(_vm._s(_vm.controller.drug.name))]), _vm._v(" "), _c('DrugSearchSelector', {
    staticStyle: {
      "height": "auto"
    },
    model: {
      value: (_vm.controller.drug),
      callback: function($$v) {
        _vm.$set(_vm.controller, "drug", $$v)
      },
      expression: "controller.drug"
    }
  }), _vm._v(" "), (_vm.controller.drug.hasWarning || _vm.controller.drug.hasError) ? _c('span', {
    staticClass: "help-block",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-exclamation-circle': _vm.controller.drug.hasError, 'fa-exclamation-triangle': _vm.controller.drug.hasWarning
    }
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.controller.drug.message))])]) : _vm._e()], 1)]) : _c('div', [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Drug")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controller.drug.value.searchText),
      expression: "controller.drug.value.searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.controller.drug.value.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.controller.drug.value, "searchText", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('datepicker', {
    attrs: {
      "controller": _vm.controller.startDate,
      "start-date": _vm.controller.startDate.Value,
      "end-date": _vm.controller.cycle.endDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('datepicker', {
    attrs: {
      "controller": _vm.controller.endDate,
      "start-date": _vm.today,
      "end-date": _vm.controller.cycle.endDate
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.quantity
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.unitOfMeasure
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.notes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('formcheckbox', {
    attrs: {
      "controller": _vm.controller.isInsulin
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('formcheckbox', {
    attrs: {
      "controller": _vm.controller.showInEMAR
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('formcheckbox', {
    attrs: {
      "controller": _vm.controller.treatAsCD
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('formcheckbox', {
    attrs: {
      "controller": _vm.controller.useBodyMap
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4e974cad", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e974cad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/PatientMedProfile2/DispensationItemBasicEditor.scp.html
// module id = 542
// module chunks = 0